import React from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import { SideNavigation } from '@ar/components/SideNavigation/SideNavigation';
import { PADModal } from '@/ap/components/PADModal';

const AR_GTM_TAG_ID = process.env.AR_GTM_TAG_ID ?? '';
/**
 * The AR page layout
 */
export function ArPageLayout() {
    return (
        <div className="flex h-full flex-wrap">
            <Helmet>
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${AR_GTM_TAG_ID}`}/>
                <script>
                    {`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', ${JSON.stringify(AR_GTM_TAG_ID)});
                    `}
                </script>
            </Helmet>
            <SideNavigation />
            <div className="flex w-full flex-1 flex-col overflow-auto p-10 h-screen">
                <Outlet />
            </div>
            {/* TODO: check what's the expected behavior for the PADModal */}
            <PADModal />
        </div>
    );
}
